/* help: раздел «Как пользоваться» на главной (help.tsx, help-api.ts) — статьи из docs/help и помощник по ним. Ключ — русская строка как в коде. */
const d: Record<string, string> = {
  "Как пользоваться": "How to use",
  "Короткие статьи по каждому разделу и помощник, который отвечает по ним.": "Short articles for every section and an assistant that answers from them.",
  "Спросить помощника": "Ask the assistant",
  "Например: как передать диалог коллеге?": "For example: how do I hand a conversation to a colleague?",
  "Думаю…": "Thinking…",
  "Спросить": "Ask",
  "Помощник не включён: нет ключа OpenRouter. Статьи ниже работают без него.": "The assistant is off: no OpenRouter key. The articles below work without it.",
  "Подробнее:": "Read more:",
  "Общее": "General",
  "Открыть раздел «{name}»": "Open the “{name}” section",
};
export default d;
